module.exports = __webpack_public_path__ + "img/lianti1.ef2f38ed.png";